export default {"src":"/_next/static/media/lachner-logo.9b0a593e.svg","height":19,"width":87,"blurWidth":0,"blurHeight":0};